import React, { useState } from "react";
import { RiEdit2Fill } from "react-icons/ri";
import { FiLogOut } from "react-icons/fi";
import useAuth from "../useAuth";
import userPic from "../assets/user.png";
export const ProfilePage = () => {
  const { user, logout } = useAuth();

  return (
    <div className="">
      <div className="box-border flex flex-col items-center h-80 w-full p-2 border-2 bg-slate-50 rounded-md">
        <img src={userPic} alt="person" className=" rounded-full h-36 w-36 " />
        <h3 className="font-semibold text-blue-900">
          Hi, {user?.firstName || "User"}
        </h3>
        <p className="font-semibold text-blue-900">
          Email - {user?.userName || "---"}
        </p>
        <p className="font-semibold text-blue-900">
          Phone - {user?.mobile || "---"}{" "}
        </p>
        <div className=" mt-4 flex gap-5">
          <button
            onClick={logout}
            className=" box-border gap-1 flex items-center justify-center text-white h-12 w-28 border-red-800 rounded-full bg-red-500"
          >
            Logout
            <div className="">
              <FiLogOut />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};
